enum TaskStatus {
  CANCELED = 'canceled',
  COMPLETED = 'completed',
  IN_PROGRESS = 'inProgress',
  NOT_STARTED = 'notStarted',
  OVERDUE = 'overdue',
  PLANNED = 'planned',
}

export default TaskStatus
